module.exports = __webpack_public_path__ + "static/assets/340d9d4db94c4557ddcc7bbe6e39e4ce.png";